import styled from 'styled-components';
import {Btn} from '../../elements/button/btn-type/Btn';
import {Icon} from '../../elements/Icon/Icon';

export const ModalCloseBtn = styled(Btn)`
    color: var(--label-text-color);
    &:hover {
        color: var(--primary);
    }
    ${Icon.Wrapper} svg {
        width: 20px;
        height: 20px;
    }
`;
